import { lesson15Activity1, lesson15Activity2, lesson15Activity3 } from './assignments'
import { WHITE_PIECE_SEARCH_KEY, BLACK_INITIAL_MOVE, BLACK_PIECE_SEARCH_KEY, WHITE_INITIAL_MOVE } from '../../utils/constants';
import { createChessboard } from '../../utils';

let lessonConfig = [
    {
        id: 0,
        previous: null,
        next: 2,
        video: {
            src: 'img/videos/lesson_15/1.mp4',
            startTime: 0,
            autoStartNext: true,
            next: 1
        }
    },
    {
        id: 1,
        previous: 0,
        next: 2,
        audio: { src: 'img/audio/lesson_15/1.mp3', start: true, controls: false },
        chessboard: {
            board: lesson15Activity1({
                showIndicators: { allSides: true },
                piecesArray: [ 'bQ', 'bR' ],
                validatePieces: { 'bQ': [ 'c4','d2' ], 'bR': [ 'd2','c4' ] },
                pieceLimit: { bQ: 3, bR: 1 },
                position: '8/8/8/8/8/q7/8/1q6',
                fen: ['8/8/8/8/2q5/q7/3r4/1q6', '8/8/8/8/2r5/q7/3q4/1q6'],
                pieceTheme: 'assignment_15_1',
                assignmentClass: 'custom-sparepiece',
                next: 2
            })
        },
        directions: {
            data: `<b>DIRECTIONS</b><br/>Drag the queens to square on board such that none of them see each other.`
        }
    },
    {
        id: 2,
        previous: 0,
        next: 4,
        video: {
            src: 'img/videos/lesson_15/2.mp4',
            startTime: 0,
            autoStartNext: true,
            next: 3
        }
    },
    {
        id: 3,
        previous: 2,
        next: 4,
        audio: { src: 'img/audio/lesson_15/1.mp3', start: true, controls: false },
        chessboard: {
            board: lesson15Activity2({
                showIndicators: { allSides: true },
                piecesArray: ['bQ', 'bR', 'bB', 'bN', 'wQ', 'wR', 'wB', 'wN'],
                pieceLimit: { bQ: 1, bR: 1, bB: 1, bN: 1, wQ: 1, wR: 1, wB: 1, wN: 1 },
                position: '8/8/8/8/8/8/8/8',
                pieceTheme: 'assignment_15_1',
                assignmentClass: 'custom-sparepiece',
                next: 4
            })
        },
        directions: {
            data: `<b>DIRECTIONS</b><br/>Drag the Queens and place them on the board so none of them see each other.`
        }
    },
    {
        id: 4,
        previous: 2,
        next: 6,
        video: {
            src: 'img/videos/lesson_15/3.mp4',
            startTime: 0,
            autoStartNext: true,
            next: 5
        }
    },
    {
        id: 5,
        previous: 4,
        next: 6,
        audio: { src: 'img/audio/lesson_15/2.mp3', start: true, controls: false },
        chessboard: {
            board: lesson15Activity3({
                showIndicators: { allSides: true },
                position: '8/5pk1/8/RP2q3/8/7P/5PP1/6K1',
                resultFen: '8/5pk1/8/RP6/8/7P/5PP1/4q1K1',
                assignmentClass: 'custom-sparepiece',
                from: 'a5',
                to: 'a1',
                restrictMoveOf: WHITE_PIECE_SEARCH_KEY,
                initialMoveOf: BLACK_INITIAL_MOVE,
                next: 6
            }),
            positionFen: '8/5pk1/8/RP2q3/8/7P/5PP1/6K1 b - - 0 1'
        }
    },
    {
        id: 6,
        previous: 4,
        next: 8,
        video: {
            src: 'img/videos/lesson_15/4.mp4',
            startTime: 0,
            autoStartNext: true,
            next: 7
        }
    },
    {
        id: 7,
        previous: 6,
        next: 8,
        audio: { src: 'img/audio/lesson_15/3.mp3', start: true, controls: false },
        chessboard: {
            board: lesson15Activity3({
                showIndicators: { allSides: true },
                position: '1k6/8/8/8/1K4Q1/8/8/8',
                resultFen: '1k6/3Q4/8/8/1K6/8/8/8',
                assignmentClass: 'custom-sparepiece',
                restrictMoveOf: BLACK_PIECE_SEARCH_KEY,
                initialMoveOf: WHITE_INITIAL_MOVE,
                next: 8
            }),
            positionFen: '1k6/8/8/8/1K4Q1/8/8/8 w - - 0 1'
        }
    },
    {
        id: 8,
        previous: 6,
        next: 9,
        video: {
            src: 'img/videos/lesson_15/5.mp4',
            startTime: 0,
            autoStartNext: true,
            next: 9
        }
    },
    {
        id: 9,
        previous: 8,
        next: 10,
        audio: { src: 'img/audio/qa_bgm.mp3', start: true, loop: true },
        qa: {
            id: 0,
            question: 'The Crowded Queendom is a make believe land where...',
            answer: [
                'Too many peasants fill the castle',
                'Too many Queens fill the castle',
                'There are many Kings and Queens',
                'There are many apartments and no farm land'
            ],
            rightAnswer: 'Too many Queens fill the castle',
            validateAnswer: { rightAnswer: 1, userAnswer: -1 },
            styleClass: 'xl'
        }
    },
    {
        id: 10,
        previous: 8,
        next: 11,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 1,
            question: 'The Crowded Queendom is a chess puzzle using...',
            answer: [
                '8 Queens',
                '8 Kings',
                '16 Queens',
                '16 Kings'
            ],
            rightAnswer: '8 Queens',
            validateAnswer: { rightAnswer: 0, userAnswer: -1 },
            styleClass: 'md'
        }
    },
    {
        id: 11,
        previous: 8,
        next: 12,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 2,
            question: 'The goal of the Crowded Queendom is...',
            answer: [
                'To promote all of your pawns to Queens',
                'To have your Queen capture the King in five moves',
                'To promote your Queens to Knights, Bishops or Rooks',
                'To place 8 Queens so none of them see each other'
            ],
            rightAnswer: 'To place 8 Queens so none of them see each other',
            validateAnswer: { rightAnswer: 3, userAnswer: -1 },
            styleClass: 'xl'
        }
    },
    {
        id: 12,
        previous: 8,
        next: 13,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 3,
            question: 'In the Crowded Queendom, the Queens cannot...',
            answer: [
                'Share a file',
                'Share a rank',
                'Share a diagonal',
                'All of the above'
            ],
            rightAnswer: 'All of the above',
            validateAnswer: { rightAnswer: 3, userAnswer: -1 },
            styleClass: 'md'
        }
    },
    {
        id: 13,
        previous: 8,
        next: 14,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 4,
            question: 'What does, "Keep the Queens a Knight move away" mean?',
            answer: [
                'There should be a Knight in between the King and Queen',
                'The Queen should always stand next to a Knight',
                'The Queens should be an L-shape away from each other',
                'The Queens only move after the Knight moves'
            ],
            rightAnswer: 'The Queens should be an L-shape away from each other',
            validateAnswer: { rightAnswer: 2, userAnswer: -1 },
            styleClass: 'xl'
        }
    },
    {
        id: 14,
        previous: 8,
        next: 15,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 5,
            question: 'In the end game, your Queen should try to...',
            answer: [
                'Use her double attack skills',
                'Get promoted',
                'Move to the corners of the board',
                'All of the above'
            ],
            rightAnswer: 'Use her double attack skills',
            validateAnswer: { rightAnswer: 0, userAnswer: -1 },
            styleClass: 'lg'
        }
    },
    {
        id: 15,
        previous: 8,
        next: 16,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 6,
            question: 'Since Queens don\'t like competition, what should they do in the end game?',
            answer: [
                'Avoid going to the opposite side of the board',
                'Capture their opponents Knights',
                'Capture pawns close to promoting',
                'All of the above'
            ],
            rightAnswer: 'Capture pawns close to promoting',
            validateAnswer: { rightAnswer: 2, userAnswer: -1 },
            styleClass: 'lg'
        }
    },
    {
        id: 16,
        previous: 8,
        next: 17,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 7,
            question: 'What does "equestrian Queen" mean in chess?',
            answer: [
                'A Queen that rides a horse',
                'Having too many Queens',
                'Having your Queen jump over other pieces',
                'Keeping your Queen a Knight move away from the King'
            ],
            rightAnswer: 'Keeping your Queen a Knight move away from the King',
            validateAnswer: { rightAnswer: 3, userAnswer: -1 },
            styleClass: 'xl'
        }
    },
    {
        id: 17,
        previous: 8,
        next: 18,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 8,
            question: 'Where can you place one more Queen to complete the "Crowded Queendom"',
            answer: [
                'Qe4',
                'Qe2',
                'Qf3',
                'Qg2'
            ],
            rightAnswer: 'Qe2',
            validateAnswer: { rightAnswer: 1, userAnswer: -1 },
            styleClass: 'md',
            chessboard: {
                board: createChessboard({
                    showIndicators: true,
                    position: '5Q2/3Q4/6Q1/Q7/7Q/1Q6/8/2Q5'
                }),
                hint: true
            }
        }
    },
    {
        id: 18,
        previous: 8,
        next: 19,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 9,
            question: 'Look at this board carefully. White has two great moves. Which ones are both good?',
            answer: [
                'Bg2+ and Nd6+',
                'Ng7 and Ba6',
                'Nf6+ and Be2',
                'Bg2+ and Ng7'
            ],
            rightAnswer: 'Bg2+ and Nd6+',
            validateAnswer: { rightAnswer: 0, userAnswer: -1 },
            styleClass: 'xl',
            chessboard: {
                board: createChessboard({
                    showIndicators: true,
                    position: '4N3/1q6/8/7p/4k3/8/5P2/5BK1'
                }),
                hint: true
            }
        }
    },
    {
        id: 19,
        previous: 8,
        next: null,
        audio: { src: null, stop: true },
        qa: {
          position: 'center',
          nextLesson: 'Lesson Sixteen',
          result: true,
          styleClass: 'xl',
          timeout: 7000
        }
      },
];

let assets = [
    'img/background_14.png',
    'img/background_15.png',
    'img/background_16.png',
];

let config = {
    config: lessonConfig,
    assets: assets
};

export default config;



// WEBPACK FOOTER //
// ./src/lessons/lesson_15/index.js